// Employees Mentioned — flatten employeesMentioned across records, count
// frequency, sortable desc. The staff-conduct signal.
import React, { useState } from "react";
import { ReportShell, Card, MiniBars, EmptyState } from "./_shared";
import { categoryLabel } from "../grievanceModel";

export default function EmployeesMentioned({ records = [] }) {
  const [dir, setDir] = useState("desc");

  const tally = {};
  records.forEach((r) => {
    (r.employeesMentioned || []).forEach((name) => {
      const n = (name || "").trim();
      if (!n) return;
      if (!tally[n]) tally[n] = { name: n, count: 0, categories: {} };
      tally[n].count += 1;
      const cat = r.category || "other";
      tally[n].categories[cat] = (tally[n].categories[cat] || 0) + 1;
    });
  });

  const rows = Object.values(tally).sort((a, b) => (dir === "desc" ? b.count - a.count : a.count - b.count));
  const bars = [...rows].sort((a, b) => b.count - a.count).slice(0, 12).map((r) => ({ label: r.name, value: r.count, color: "var(--ed-violet)" }));

  return (
    <ReportShell
      title="Employees Mentioned"
      subtitle="Staff named across grievance records — frequency signal for conduct trends."
      right={<button className="btn-secondary" style={{ fontSize: 12, padding: "6px 14px" }} onClick={() => setDir((d) => (d === "desc" ? "asc" : "desc"))}>Sort: {dir === "desc" ? "Most ▼" : "Fewest ▲"}</button>}
    >
      {rows.length === 0 ? (
        <EmptyState>No employees mentioned in grievances for this scope.</EmptyState>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(320px,1fr))", gap: 16 }}>
          <Card>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13.5 }}>
              <thead>
                <tr style={{ borderBottom: "1px solid var(--ed-line)" }}>
                  <th style={{ textAlign: "left", padding: "8px 10px", fontSize: 11, fontWeight: 700, color: "var(--ed-muted)", textTransform: "uppercase" }}>Employee</th>
                  <th style={{ textAlign: "right", padding: "8px 10px", fontSize: 11, fontWeight: 700, color: "var(--ed-muted)", textTransform: "uppercase" }}>Mentions</th>
                  <th style={{ textAlign: "left", padding: "8px 10px", fontSize: 11, fontWeight: 700, color: "var(--ed-muted)", textTransform: "uppercase" }}>Categories</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.name} className="table-row" style={{ borderBottom: "1px solid var(--ed-line-2)" }}>
                    <td style={{ padding: "10px", fontWeight: 600, color: "var(--ed-ink)" }}>{r.name}</td>
                    <td style={{ padding: "10px", textAlign: "right", fontWeight: 800, color: r.count > 1 ? "#be123c" : "var(--ed-ink)" }}>{r.count}</td>
                    <td style={{ padding: "10px", fontSize: 12, color: "var(--ed-muted)" }}>{Object.keys(r.categories).map((c) => categoryLabel(c)).join(", ")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
          <Card><div className="section-header">Most Mentioned</div><MiniBars data={bars} /></Card>
        </div>
      )}
    </ReportShell>
  );
}
